(function () {
  'use strict';

  window.tayStartNativeGallery = function () {
    if (
      window.innerWidth >= 768 ||
      !window.themeVendor ||
      !window.themeVendor.Flickity
    ) return;

    var Flickity = window.themeVendor.Flickity;

    document.querySelectorAll(
      '.product-gallery__media-slider'
    ).forEach(function (gallery) {
      if (gallery.classList.contains('tay-native-gallery')) return;

      var flickity = Flickity.data(gallery);
      if (!flickity || !flickity.isActive) return;

      var slides = flickity.cells.map(function (cell) {
        return cell.element;
      });

      if (slides.length < 2) return;

      var section = gallery.closest('.shopify-section');
      if (!section) return;

      var thumbs = section.querySelector(
        '[data-product-single-media-thumbs]'
      );

      var nav = thumbs ? Flickity.data(thumbs) : null;
      var initialIndex = flickity.selectedIndex || 0;

      [flickity, nav].forEach(function (instance) {
  if (!instance) return;

  var originalAnimate = instance.animate;

  instance.animate = function () {
    if (!this.isActive) {
      this.isAnimating = false;
      return;
    }

    return originalAnimate.apply(this, arguments);
  };

  instance.isAnimating = false;
});

if (nav && nav.isActive) nav.deactivate();
flickity.deactivate();


      gallery.classList.add('tay-native-gallery');

      function update(index, scroll) {
        index = Math.max(0, Math.min(slides.length - 1, index));

        flickity.selectedIndex = index;
        flickity.updateSelectedSlide();

        slides.forEach(function (slide, position) {
          slide.setAttribute('aria-hidden', 'false');
          slide.classList.toggle('is-selected', position === index);
        });

        if (thumbs) {
          thumbs.querySelectorAll(
            '.product-single__thumbnail'
          ).forEach(function (thumb, position) {
            thumb.classList.toggle(
              'is-nav-selected',
              position === index
            );
          });
        }

        if (scroll) {
          gallery.scrollTo({
            left: slides[index].offsetLeft - slides[0].offsetLeft,
            behavior: 'smooth'
          });
        }

        flickity.dispatchEvent('change', null, [index]);
        scheduleSettle();
      }

      flickity.select = function (index) {

        var parsedIndex = Number(index);

        if (Number.isFinite(parsedIndex)) {
          update(parsedIndex, true);
        }
      };

      if (thumbs) {
        thumbs.querySelectorAll(
          '.product-single__thumbnail-link'
        ).forEach(function (link, index) {
          link.addEventListener('click', function (event) {
            event.preventDefault();
            update(index, true);
          });
        });
      }

      var framePending = false;
var settleTimer;

function scheduleSettle() {
  clearTimeout(settleTimer);

  settleTimer = setTimeout(function () {
    if (!gallery.isConnected || gallery.clientWidth === 0) return;

    var index = Math.round(
      gallery.scrollLeft / gallery.clientWidth
    );

    index = Math.max(0, Math.min(slides.length - 1, index));

    if (index !== flickity.selectedIndex) {
      update(index, false);
      return;
    }

    flickity.dispatchEvent('settle', null, [index]);
  }, 180);
}

gallery.addEventListener('scroll', scheduleSettle, {
  passive: true
});


      gallery.addEventListener('scroll', function () {
        if (framePending) return;

        framePending = true;

        requestAnimationFrame(function () {
          framePending = false;

          var index = Math.round(
            gallery.scrollLeft / gallery.clientWidth
          );

          if (index !== flickity.selectedIndex) {
            update(index, false);
          }
        });
      }, { passive: true });

      update(initialIndex, false);

      requestAnimationFrame(function () {
        gallery.scrollLeft =
          slides[initialIndex].offsetLeft - slides[0].offsetLeft;
      });
    });
  };
})();